module.exports = __webpack_public_path__ + "static/media/kid16.9269f7f3.png";